<template>
  <div>
    <app-header />
    <mpn-page-title :title="pageTitle" />
    <main class="a-service-main">
      <div class="a-service-container">
        <div class="mypack_final mypack_final_renew">
          <div class="packing">
            <div class="box_title_area">
              <h3 class="service-title-b">신청내역</h3>
            </div>
            <div class="list_wrap list_wrap_renew" v-if="hasData">
              <ul class="list tow_colum_type">
                <li>
                  <div class="list_title">팩 이름</div>
                  <div class="list_cont">{{ orderInfo.mypack_name }}</div>
                </li>
                <li>
                  <div class="list_title">정기 구매 기간</div>
                  <div class="list_cont">
                    {{ orderInfo.billing_period }}
                  </div>
                </li>
                <li>
                  <div class="list_title">회차</div>
                  <div class="list_cont">
                    <span>{{ orderInfo.cur_seq }}</span
                    >회차 / 12회차
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <final-applied-item-info
            v-if="hasData"
            :desktop="!isMobile"
            activeButton=""
            :final-products="finalProducts"
            :days="days"
            :pockets="pockets"
            :prices="prices"
          >
            <p class="desc">
              * 마이팩 포장비 : 30포 당 1,500원 / 배송비 : 6만원 이하 주문 시
              3,300원이 포함된 금액입니다.
            </p>
          </final-applied-item-info>
          <div class="choice-item mpn-ship">
            <div class="check_notice_wrap">
              <div class="check_notice_cont">
                <input
                  class="amwa-checkbox"
                  type="checkbox"
                  name="chknotice"
                  id="chknotice"
                  v-model="isCheckNotice"
                />
                <label for="chknotice" class="focus"
                  >정기 구매의 경우 2회차 부터는 배달수령으로만 제품이
                  배송됩니다.</label
                >
              </div>
            </div>

            <div class="box_title_area">
              <h3 class="service-title-b">
                이전 마이팩과 동일한 상담내용(제품, 섭취인, 건강상태 등)으로
                제품을 구매하시겠습니까?
              </h3>
            </div>

            <div class="choice-abc choice-abc-renew">
              <div class="form_group-element">
                <span class="form_element-checkbox">
                  <input
                    type="checkbox"
                    name="sameAsPreviousPack"
                    id="sameAsPreviousPack"
                    v-model="isSameAsPreviousPack"
                  />
                  <label for="sameAsPreviousPack" class="sp_chk focus"
                    >예</label
                  >
                </span>
              </div>
            </div>
          </div>
        </div>
        <div class="btn_group type2">
          <div>
            <button
              type="button"
              class="btn_default-a medium mo_hidden"
              @click="onClose"
            >
              취소
            </button>
            <button
              type="button"
              class="btn_default-b medium mo_hidden"
              :disabled="!canConfirm"
              @click="onConfirm"
            >
              확인
            </button>
          </div>
        </div>
      </div>
      <div class="box_mobile-floating">
        <div class="btn_floating-group">
          <span class="btn_box">
            <button type="button" class="btn_square-c" @click="onCancel">
              취소
            </button>
          </span>
          <span class="btn_box">
            <button
              type="button"
              class="btn_square-a"
              :disabled="!canConfirm"
              @click="onConfirm"
            >
              확인
            </button>
          </span>
        </div>
      </div>
    </main>
    <app-footer />
    <modal-unavailable-products
      v-if="soldoutProducts"
      ref="refSoldout"
      :purchase-type="purchaseType"
      :cur-seq="curSeq"
      :re-orderble="reOrderble"
      :re-cal-dose-info="reCalDoseInfo"
      :soldout-products="soldoutProducts"
      @remove-and-proceed="removeAndProceed"
      @cancel-pack="cancelPack"
    />
    <modal-alert ref="refAlert" />
    <modal-confirm ref="refConfirm" />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import {
  PACK_STATUS_CODE,
  DELIVERY_FEE_SKU,
  PACKAGE_WRAPPING_FEE_SKU,
} from "@/utils/constants";
import { log } from "@/utils/common";
import orderApi from "@/apis/order";
import packApi from "@/apis/pack";
import productApi from "@/apis/product";
import productHelpers from "@/utils/helpers/product";
import AppHeader from "@/components/AppHeader.vue";
import AppFooter from "@/components/AppFooter.vue";
import MainButtonGroup from "@/components/MainButtonGroup.vue";
import FloatingButtonGroup from "@/components/FloatingButtonGroup.vue";
import FinalAppliedItemInfo from "@/components/final-check/FinalAppliedItemInfo.vue";
import ModalUnavailableProducts from "@/components/modal-popups/ModalUnavailableProducts.vue";
import ModalAlert from "@/components/global/ModalAlert.vue";
import ModalConfirm from "@/components/global/ModalConfirm.vue";

export default {
  name: "MypackConsultation",
  components: {
    AppHeader,
    AppFooter,
    FinalAppliedItemInfo,
    FloatingButtonGroup,
    MainButtonGroup,
    ModalUnavailableProducts,
    ModalAlert,
    ModalConfirm,
  },
  async beforeRouteEnter(to, from, next) {
    const { id } = to.params;
    if (isNaN(id)) {
      next("/");
      return;
    }
    const r = await packApi.getApplianceDetail(id);
    if (r.error) {
      next("/");
    } else {
      if (from.name) {
        sessionStorage.setItem("prevPage", from.fullPath);
      }
      next((vm) => vm.init(r));
    }
  },
  data() {
    return {
      isMobile: "ontouchstart" in document.documentElement,
      pageTitle: "마이팩 정기구매",
      isCheckNotice: false,
      isSameAsPreviousPack: false,

      isSoldout: null,
      soldoutSkus: null,
      soldoutName: null,
      isEndOfSale: null,
      endOfSaleSkus: null,
      endOfSaleName: null,
      reOrderble: null,
      reCalDoseInfo: null,
      soldoutProducts: null,

      orderInfo: null,
      orderDetailList: null,
      finalSkus: null,
      prices: null,
    };
  },
  computed: {
    ...mapGetters({
      products: "product/productsAll",
      productsFetched: "product/productsFetched",
    }),
    finalProducts() {
      if ((this.productsFetched == 0, this.finalSkus.length == 0)) return [];
      else
        return productHelpers.getProductsFromSkus(
          this.products,
          this.finalSkus
        );
    },
    days() {
      return this.orderInfo.take_days;
    },
    pockets() {
      return this.orderDetailList.length > 0 ? this.orderDetailList[0].dose : 0;
    },
    hasData() {
      return (
        this.productsFetched &&
        this.finalSkus != null &&
        this.orderInfo != null &&
        this.orderDetailList != null
      );
    },
    reqNo() {
      return this.orderInfo.req_no;
    },
    canConfirm() {
      return this.isCheckNotice && this.isSameAsPreviousPack;
    },
    purchaseType() {
      return this.orderInfo.purchase_type;
    },
    curSeq() {
      return this.orderInfo.cur_seq;
    },
    abcCd() {
      return this.orderInfo.abc_cd;
    },
    productsDetails() {
      return this.orderDetailList.map((n) => ({
        item_name: n.item_name,
        item_sku: n.item_sku,
        pockets: n.dose,
        seq: n.dose_list,
      }));
    },
    isCheckout() {
      return (
        this.orderInfo.pack_status == PACK_STATUS_CODE.CONSULTATION_REQUESTED &&
        this.orderInfo.auto_pay_due == 1
      );
    },
  },
  methods: {
    async init(r) {
      this.orderList = r;
      this.orderInfo = r.order_info[0];
      this.orderDetailList = r.order_detail_list;
      this.finalSkus = this.orderDetailList.map((n) => ({
        days: this.days,
        item_sku: n.item_sku,
        pockets: this.pockets,
        seq: n.dose_list,
      }));

      const doseInfo = this.finalProducts.map((n) => ({
        item_sku: n.item_sku,
        dose_cnt: n.seq
          .split(",")
          .reduce((acc, n2) => acc + parseInt(n2, 10), 0),
      }));

      const params = {
        dose_info: doseInfo,
        take_days: this.days,
      };

      try {
        const r = await productApi.getCalculatedPrices(params);

        // 포장비
        const packageWrappingFeeSku = this.products.find(
          (m) => PACKAGE_WRAPPING_FEE_SKU === m.item_sku
        );
        const packageWrappingFee =
          this.pockets * this.days * packageWrappingFeeSku.price;
        r.price += packageWrappingFee;

        // 무조건 배달
        if (r.price < 60000) {
          const deliveryFeeSku = this.products.find(
            (m) => DELIVERY_FEE_SKU === m.item_sku
          );
          const deliveryFee = deliveryFeeSku.price;
          r.price += deliveryFee;
        }
        this.prices = r;
      } catch (e) {
        log("MypackConsultation::init.catch", e);
      }

      const { purchase_type, billing_status, cur_seq, pack_status } =
        this.orderInfo;
      let message = "";
      if (purchase_type != "recurring") {
        message = "정기구매 마이팩이 아닙니다.";
      } else if (billing_status == "CANCELLED") {
        message = "정기구매가 취소된 마이팩입니다.";
      } else if (cur_seq == 1) {
        message = "간편 상담은 2회차 부터 가능합니다.";
      } else if (pack_status == PACK_STATUS_CODE.CONSULTATION_FINISHED) {
        message = "이미 재주문 신청이 완료되었습니다.";
      }

      if (!!message) {
        await this.$refs.refAlert.openWithMessage(message);
        await this.onClose();
      }
    },
    async onConfirm() {
      const isUnavailableProducts = await this.isUnavailableProducts();
      if (isUnavailableProducts) {
        await this.$refs.refSoldout.open();
        return;
      }
      await this.confirmConsultation();
    },
    async confirmConsultation() {
      const r = await packApi.confirmConsultation(this.reqNo);
      if (r.error) {
        return;
      }
      log("confirmConsultation", r);

      if (r) {
        if (this.isCheckout) {
          const { result, error } = await orderApi.placeOrder(this.reqNo);
          log("placeOrder", result, error);

          if (error || !result) {
            await this.$refs.refAlert.openWithMessage(
              "이번 회차 신청은 완료 되었으나, 이전 입력하신 결제 정보로 결제가 완료되지 않았습니다.\n마이팩 목록에서 생성하신 마이팩에 대해 즉시 결제를 해주세요."
            );
            await this.$router.replace("/mypacks");
            return;
          }

          await this.$router.push({
            name: "order-complete",
            params: {
              orderResult: result,
            },
          });
          return;
        }
      }
      await this.$refs.refAlert.openWithMessage(
        "이번회차 신청이 완료되었습니다."
      );
      await this.onClose();
    },
    async onClose() {
      const prev = sessionStorage.getItem("prevPage");
      if (prev) {
        await this.$router.replace(prev);
        sessionStorage.removeItem("prevPage");
      } else {
        await this.$router.replace("/");
      }
    },
    async onCancel() {
      const prev = sessionStorage.getItem("prevPage");
      if (prev) {
        await this.$router.replace(prev);
        sessionStorage.removeItem("prevPage");
      } else {
        if (this.isMobile) {
          if (window.navigator.userAgent.includes("KAKAOTALK")) {
            // https://fknd12.tistory.com/171
            const os = (window.navigator.userAgent || window.navigator.vgjendor || window.opera).toLocaleLowerCase();
            if(os.indexOf("android") > -1) {
              location.href = "kakaotalk://inappbrowser/close";
            }
            else if(os.indexOf("iphone") > -1 || os.indexOf("ipad") > -1) {
              location.href = "kakaoweb://closeBrowser";
            }
            else {
              window.close();
              await this.$router.replace("/");
            }
          } else {
            window.close();
            await this.$router.replace("/");
          }
        }
      }
    },
    async isUnavailableProducts() {
      const abcCd = orderApi.getAbcCd({
        purchase_type: this.purchaseType,
        cur_seq: this.curSeq,
        abc_cd: this.abcCd,
      });
      const r = await orderApi.checkSoldOut("C", this.productsDetails, abcCd);

      if (r.error) {
        console.error(r.error);
        return;
      }
      log("######### checkSoldOut results #########", r);

      const {
        isSoldout,
        soldoutSkus,
        soldoutName,
        isEndOfSale,
        endOfSaleSkus,
        endOfSaleName,
        reOrderble,
        reCalDoseInfo,
      } = r;

      if (isSoldout || isEndOfSale) {
        this.isSoldout = isSoldout;
        this.soldoutSkus = soldoutSkus;
        this.soldoutName = soldoutName;
        this.isEndOfSale = isEndOfSale;
        this.endOfSaleSkus = endOfSaleSkus;
        this.endOfSaleName = endOfSaleName;
        this.reOrderble = reOrderble;
        this.reCalDoseInfo = reCalDoseInfo;
        this.soldoutProducts = productHelpers.getSoldoutProducts(
          this.products,
          this.productsDetails,
          this.soldoutSkus,
          this.endOfSaleSkus
        );
        return true;
      }
      return false;
    },
    async removeAndProceed() {
      try {
        await this.$refs.refConfirm.openWithMessage(
          "단종 또는 일시품절 등의 제품을 제외하고 마이팩을 주문하시겠습니까?"
        );
        const r = await orderApi.removeSoldOut(
          "D",
          [...this.soldoutSkus, ...this.endOfSaleSkus],
          this.reqNo
        );
        await this.$refs.refSoldout.onDispose();
        await this.confirmConsultation();
      } catch (e) {
        console.log(e);
      }
    },
    async cancelPack() {
      if (this.isEndOfSale) {
        try {
          await this.$refs.refConfirm.openWithMessage(
            "정기 구매 제품 중 단종 제품이 포함되어 있어, 전체 주문이 취소 처리 됩니다. 정기구매를 취소하시겠습니까?"
          );
          // 정기 구매 취소
          const r = await packApi.cancelConsultationApplied(this.reqNo);
          if (r) {
            await this.$refs.refAlert.openWithMessage(
              "마이팩 정기구매가 취소되었습니다."
            );
            await this.$refs.refSoldout.onDispose();
            await this.onClose();
          }
        } catch (e) {}
      } else if (this.isSoldout) {
        try {
          await this.$refs.refConfirm.openWithMessage(
            "정기 구매 제품 중 일시품절 제품이 포함되어 있어, 이번 회차에 한해 취소 처리 됩니다. 이번 회차 주문을 취소하시겠습니까?"
          );
          // 정기 구매 승인 후 TNA
          const r = await packApi.confirmConsultation(this.reqNo, "TNA");
          if (r) {
            await this.$refs.refAlert.openWithMessage(
              `이번 회차의 주문이 취소되었습니다.<span class="desc">* 간편 상담은 완료 되었으므로, 재고가 있는 경우 마이팩 관리에서 '재고 확인 및 결제' 버튼을 통해 즉시결제 가능합니다.</span>`
            );
            await this.$refs.refSoldout.onDispose();
            await this.onClose();
          }
        } catch (e) {}
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/mypacks/consultation/MypackConsultation.vue